import React, { useContext, useEffect, useState } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import { AppBar, Card, CardHeader, Stack, Tab, Tabs } from "@mui/material";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialDataGrid from "../../../../components/MaterialDataGrid";
import BASEURL from "../../../Utils/Baseurl";
import {
  fecthResignationTableData,
  myResignationList,
  teamResignationList,
} from "../GraphQl";
import request from "graphql-request";
import { useNavigate } from "react-router-dom";
import { useUserDetails } from "../../../../context/auth";
import MaterialBox from "../../../../components/MaterialBox";
import { DesignationContext } from "../../../../context/designationcontext";

const ResignationTabel = () => {
  const { AccessData } = useUserDetails();
  console.log("AccessData", AccessData);
  const { setDesignation } = useContext(DesignationContext);
  const userData = JSON.parse(sessionStorage.getItem("user"));
  const tablist = JSON.parse(sessionStorage.getItem("resignationTap"));

  const myId = userData.id;
  let MainValue;
  const navigate = useNavigate();
  const [tableData, setTableData] = useState([]);
  const [value, setValue] = useState(MainValue || "Employee");
  if (
    AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some(
      (item) => item.component === "HrApproval" && item.can_access,
    )
  ) {
    if (tablist === "HR List") {
      MainValue = "HR List";
    } else if (tablist === "Team List") {
      MainValue = "Team List";
    } else {
      MainValue = "Employee";
    }
  }

  if (
    AccessData &&
    Array.isArray(AccessData) &&
    AccessData.some(
      (item) => item.component === "ManagerApproval" && item.can_access,
    )
  ) {
    if (tablist === "Team List") {
      MainValue = "Team List";
    } else {
      MainValue = "Employee";
    }
  }

  if (
    AccessData &&
    Array.isArray(AccessData) &&
    !AccessData.some(
      (item) =>
        item.component === "ManagerApproval" || item.component === "HrApproval",
    )
  ) {
    MainValue = "Employee";
  }

  useEffect(() => {
    const tabName = JSON.parse(sessionStorage.getItem("resignationTap"));

    if (tabName) {
      setValue(tabName);
    } else {
      setValue("Employee");
    }
  }, []);

  useEffect(() => {
    if (value == "Employee") {
      const fetchEmployeeList = async () => {
        try {
          const response = await request(BASEURL, myResignationList, {
            id: myId,
          });
          const data = response?.allResignationFormsUser;
          setTableData(data);
          console.log("12333", data);
        } catch (error) {
          console.error("Error fetching Data ", error);
        }
      };
      fetchEmployeeList();
    }

    if (value == "Team List") {
      const fetchTeamList = async () => {
        try {
          const response = await request(BASEURL, teamResignationList, {
            id: myId,
          });

          const data = response?.resignationRequestTeam.data;
          console.log("teamlist", data);
          setTableData(data);
        } catch (error) {
          console.error("Couldn't fetch Data: ", error);
        }
      };
      fetchTeamList();
    }

    if (value == "HR List") {
      const fetchResignationData = async () => {
        try {
          const response = await request(BASEURL, fecthResignationTableData);
          console.log("dasa", response.allResignationForms);
          const data = response?.allResignationForms;
          setTableData(data);
        } catch (error) {
          console.error("Error fetching Data", error);
        }
      };
      fetchResignationData();
    }
  }, [value]);

  const dataListTable = {
    columns: [
      {
        headerName: "S.No",
        field: "sno",
        name: "S No",
        width: 50,
        disableColumnMenu: true,
        editable: false,
      },
      {
        headerName: "EMP ID",
        field: "employeeId",
        name: "employeeId",
        flex: 0.8,
        editable: false,
        disableColumnMenu: true,
      },
      {
        headerName: "Name",
        field: "employeeName",
        name: "employeeName",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        headerName: "Designation",
        field: "designation",
        name: "designation",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        headerName: "Department",
        field: "department",
        name: "department",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        headerName: "Date Of Resignation",
        field: "dateOfResignation",
        name: "dateOfResignation",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        headerName: "Reason",
        field: "reason",
        name: "reason",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        headerName: "Notice Period",
        field: "noticePeriod",
        name: "noticePeriod",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        headerName: "Manager Approval",
        field: "teamApproval",
        name: "Manager Approval",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        headerName: "HR Approval",
        field: "hrApproval",
        name: "HR Approval",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        headerName: "Created At",
        field: "createdAt",
        name: "Created At",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
    ],
    rows: tableData?.map((val, index) => ({
      sno: index + 1,
      id: val.id,
      employeeId: val.employeeId,
      employeeName: val.employeeName,
      designation: val.designation,
      department: val.department,
      dateOfResignation: val.dateOfResignation,
      reason: val.reason,
      otherReason: val.otherReason,
      noticePeriod: val.noticePeriod,
      stateamApprovalMessagetus: val.teamApprovalMessage,
      hrApprovalMessage: val.hrApprovalMessage,
      teamApproval: val.teamApproval,
      hrApproval: val.hrApproval,
      status: val.status,
      createdAt: val?.createdAt.slice(0, 10),
    })),
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue == "HR List") {
      sessionStorage.setItem("resignationTap", JSON.stringify(newValue));
    } else if (newValue == "Manager") {
    } else if (newValue == "Team List") {
      sessionStorage.setItem("resignationTap", JSON.stringify(newValue));
    } else if (newValue == "ManagerList") {
      sessionStorage.setItem("resignationTap", JSON.stringify(newValue));
    } else if (newValue == "Employee") {
      sessionStorage.setItem("resignationTap", JSON.stringify(newValue));
    }
  };
  const onOthersListClick = (e) => {
    if (e?.id) {
      navigate(`/resignation-list/resignation-approval?${e?.id}`);
    }
  };

  const onDataListClick = (e) => {
    if (e?.id) {
      navigate(`/resignation-form?${e?.id}`);
    }
  };

  const onRowClick = (e) => {
    console.log(e, "event");

    if (!e?.id) return;

    const { hrApproval, teamApproval, status } = e.row;

    console.log(e.row, "roowdata");

    console.log(value, "vallrol");

    if (value === "Employee") {
      const viewConditions = [
        hrApproval === "pending" &&
          teamApproval === "approved" &&
          // status === "Approved",
          // hrApproval === "Pending" &&
          //   teamApproval === "Approved" &&
          //   status === "Pending",
          hrApproval === "pending" &&
          teamApproval === "rejected" &&
          // status === "Rejected",
          hrApproval === "rejected" &&
          teamApproval === "rejected",
        // status === "Rejected",
      ];

      

      if (teamApproval != "Approved") {
        navigate(`/resignation-form?id=${e.id}`);
        return;
      }

      if (
        hrApproval === "pending" &&
        teamApproval === "pending" &&
        status === "pending"
      ) {
        console.log("Correct");
        navigate(`/resignation-form?id=${e.id}`);
        return;
      }

      console.log("rowclicked");
    }

    setDesignation({ value });
    navigate(
      `/resignation-list/resignation-approval?id=${(e.id)}`,
    );
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Resignation list
                </MaterialTypography>
              </Stack>
              <MaterialBox alignItems="center" width="60%">
                <MaterialBox width="80%">
                  <div style={{ position: "relative", left: "20px" }}>
                    <AppBar position="static">
                      <Tabs
                        orientation="horizontal"
                        value={value}
                        onChange={handleChange}
                        sx={{ backgroundColor: "transparent" }}
                      >
                        {/* HR List tab */}
                        {AccessData?.some(
                          (item) =>
                            item.component === "HrApproval" && item.can_access,
                        ) && <Tab label="HR List" value="HR List" />}

                        {/* Team List tab (combined logic) */}
                        {AccessData?.some(
                          (item) =>
                            (item.component === "HrApproval" ||
                              item.component === "ManagerApproval") &&
                            item.can_access,
                        ) && <Tab label="Team List" value="Team List" />}

                        {/* My List tab */}
                        <Tab label="My List" value="Employee" />
                      </Tabs>
                    </AppBar>
                  </div>
                </MaterialBox>
              </MaterialBox>
            </Stack>
          }
        />
        <MaterialDataGrid
          customHeight={500}
          rows={dataListTable.rows}
          columns={dataListTable.columns}
          isSelectable={false}
          // onRowClick={(tablist == "Employee" && onDataListClick)
          //   || onOthersListClick
          // }
          onRowClick={onRowClick}
          checkboxSelection={false}
          // loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No designation found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet added any designation details. Click on the
                  "Add designation" button to start adding designation details.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
    </DashboardLayout>
  );
};

export default ResignationTabel;
